import { Box, Center, Spinner, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useGetBidForBuyerQuery } from "../../../autogen/bff-api";
import { ReadonlyFieldLabel } from "../../sourcing-events/bid-readonly/ReadonlyAnswerCard";
import { QualificationsTab } from "../bid-detail/QualificationsTab";
import { FocusDeclarations } from "./FocusDeclarations";
import { FocusExclusionGrounds } from "./FocusExclusionGrounds";

interface Props {
  eventId: string;
  bidId: string;
}

export const QualificationFocusBody = ({ eventId, bidId }: Props) => {
  const { t } = useTranslation();
  const { data: detail, isLoading } = useGetBidForBuyerQuery({ eventId, bidId });

  if (isLoading) {
    return (
      <Center py="20">
        <Spinner color="smPrimary" />
      </Center>
    );
  }

  if (!detail) {
    return (
      <Center py="20">
        <Text color="smError">{t("Could not load the bid.")}</Text>
      </Center>
    );
  }

  return (
    <Stack spacing="8" maxW="5xl">
      <Box>
        <ReadonlyFieldLabel>{t("Qualification requirements")}</ReadonlyFieldLabel>
        <Box mt="2">
          <QualificationsTab eventId={eventId} bidId={bidId} detail={detail} />
        </Box>
      </Box>

      <Box>
        <ReadonlyFieldLabel>{t("Exclusion grounds")}</ReadonlyFieldLabel>
        <Box mt="2">
          <FocusExclusionGrounds espd={detail.espd} resetKey={bidId} />
        </Box>
      </Box>

      <Box>
        <ReadonlyFieldLabel>{t("Declarations")}</ReadonlyFieldLabel>
        <Box mt="2">
          <FocusDeclarations declarations={detail.declarations} />
        </Box>
      </Box>
    </Stack>
  );
};
